<template>
  <v-autocomplete
    class="autoComplete"
    v-bind="$attrs"
    v-on="$listeners"

  ></v-autocomplete>
</template>
<style >

.autoComplete fieldset{
    background-color: white;
    border: 1px solid #333  !important
}

.autoComplete fieldset {
  border-radius: 0  !important
}
.autoComplete .v-input__prepend-outer {
  background-color: #3e2723 !important;
  height: 40px;
  width: 40px;
  position: relative;
  top: -8px;
  padding-top: 8px;
  border-radius: 0px !important;
  margin-left: 0px;
  margin-left: 0 !important;
  margin-right: 0 !important;
  
}
.autoComplete .v-input__prepend-outer i {
  color: #ffffff !important;
}


</style>
<script>
export default {
  data() {
    return {
     
    };
  },
};
</script>